<section
  class="summary-stat-cards"
  [class.operator-summary]="variant === 'operator-home'"
  [style.max-width]="maxWidth"
  [style.gap]="gap"
  [style.grid-template-columns]="columns">
  <article
    class="summary-card"
    *ngFor="let card of cards"
    [ngStyle]="getCardStyle(card)">
    <span class="summary-icon" *ngIf="card.icon">
      <mat-icon>{{ card.icon }}</mat-icon>
    </span>
    <div class="summary-copy">
      <div class="summary-label">{{ card.label }}</div>
      <div class="summary-value">{{ card.value }}</div>
    </div>
  </article>
</section>
